<template>
  <div class="template_list">
    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="wrap-device-list_bg">
      <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
        <div class="filters">
          <div class="filter">
            <fg-input
                v-model="filter.q"
                type="text"
                :placeholder="translate('search')"
                :clearable="true"
                @input="change_input"
            />
          </div>
          <div class="filter">
            <tree-select
                :options="client_list"
                :multiple="false"
                v-model="filter.client_id"
                :placeholder="translate('client.one')"
                :clearable="true"
                @input="change_input"
            />
          </div>
          <div class="filter"></div>
          <div class="filter"></div>
          <div class="filter"></div>
          <div class="filter"></div>
        </div>
      </div>
    </div>

    <div class="response_table">
      <div v-if="loading">
        <div class="spinner">
          <scale-loader />
        </div>
      </div>

      <h3 v-else-if="!templates.length" class="text-center">{{ translate('no_data') }}</h3>

      <table v-else>
        <thead>
        <tr>
          <th
              class="pointer text-left"
              @click="change_filter('name')"
              :class="{ selected: filter_type === 'name' }"
              scope="col"
          >
            {{ translate('task_list.templates.name') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>
          <th
              class="pointer text-left"
              @click="change_filter('command')"
              :class="{ selected: filter_type === 'command' }"
              scope="col"
          >
            {{ translate('task_list.templates.command') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>
          <th
              class="pointer w15per"
              @click="change_filter('client_name')"
              :class="{ selected: filter_type === 'client_name' }"
              scope="col"
          >
            {{ translate('task_list.templates.client_name') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>
          <th
              class="pointer w7per"
              @click="change_filter('timeout')"
              :class="{ selected: filter_type === 'timeout' }"
              scope="col"
          >
            {{ translate('task_list.templates.timeout') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>
          <th
              class="pointer w10per"
              @click="change_filter('use_count')"
              :class="{ selected: filter_type === 'use_count' }"
              scope="col"
          >
            {{ translate('task_list.templates.use_count') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>
        </tr>
        </thead>
        <tbody>
          <router-link
              v-for="template in template_list"
              :key="template.id"
              :to="'/rpc_template/' + template.id"
              class="link"
          >
            <tr class="template_item pointer">
              <td class="text-left" :data-label="translate('task_list.templates.name')"> {{ template.name }} </td>
              <td class="text-left" :data-label="translate('task_list.templates.command')"> {{ template.command }} </td>
              <td class="text-left client w15per" :data-label="translate('task_list.templates.client_name')">
                <div class="client-availability" v-for="(client, client_key) in template.clients" :key="client_key">
                  <span :class="{ 'inactive-client': client.active === false || client.active === 0 || client.active === '0' }">{{ client.client_name }}</span>
                  <span class="client-use-count">{{ client.use_count }}</span>
                </div>
              </td>
              <td class="text-center w7per" :data-label="translate('task_list.templates.timeout')"> {{ template.timeout }} </td>
              <td class="text-right w10per" :data-label="translate('task_list.templates.use_count')"> {{ template.use_count }} </td>
            </tr>
          </router-link>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>

export default {
  name: 'RPCTemplates',
  data () {
    return {
      templates: [],
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
      filter:{
        client_id: null,
        q: '',
      },
      loading: false,
      filter_asc: "asc",
      filter_type: "",
    }
  },
  computed:{
    template_list(){
        let template_list = this.templates.map((template) => ({
          ...template,
          clients: [...(template.clients || [])].sort((a, b) => {
            const a_inactive = a.active === false || a.active === 0 || a.active === '0'
            const b_inactive = b.active === false || b.active === 0 || b.active === '0'
            return a_inactive - b_inactive || (Number(b.use_count) || 0) - (Number(a.use_count) || 0)
          }),
        }));
        return template_list.sort(this.compareNumbers);
    },
    client_list(){
      return this.$store.getters.getClientsList.map((client) => {
        return {label: client.name, id: client.id}
      })
    },
    sended_filter(){
      let filter = []
      Object.keys(this.filter).forEach((item) => {
        if (this.filter[item] !== null && this.filter[item] !== undefined && this.filter[item] !== ""){
          filter[item] = this.filter[item]
        }
      })
      return filter
    },
  },

  watch:{
    filter:{
      deep: true,
      handler() {
        if (this.$route.name === 'task_list_section') {
          let string = '?'
          for (let key in this.filter) {
            switch (key) {
              case 'client_id':
              case 'q':
                if (this.filter[key] !== null && this.filter[key] !== undefined && this.filter[key] !== "") {
                  string += `&${key}=${encodeURIComponent(this.filter[key])}`
                }
                break;
            }
          }
          history.replaceState(null, null, this.$route.path + string)
        }
      }
    },
  },

  created () {
    this.check_query()
  },
  activated () {
    if (this.templates.length) this.get_rpc_templates()
  },
  methods: {
    check_query(){
      if (Object.keys(this.$route.query).length > 0){
        for (let key in this.$route.query){
          switch (key) {
            case 'client_id':
              this.filter[key] = Number(this.$route.query[key]) || null
              break;
            case 'q':
              this.filter[key] = this.$route.query[key]
              break;
          }
        }
      }
      this.get_rpc_templates()
    },
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.get_rpc_templates, 500)
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    },
    get_rpc_templates(){
      this.loading = true
      this.$http.v1.getRPCIndex(this.sended_filter, (response) => {
        this.loading = false
        if (response.data){
          this.templates = response.data
        }else{
          this.global_notify('danger', this.translate('no_data'))
        }
      })
    },
  }
}

</script>
<style lang="scss" scoped>
.template_list {
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;

  .header{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 10px;
    .filters{
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      .filter{
        width: 100%;
        .form-group{
          margin: 0;
        }
      }
    }
  }

  .response_table{
    padding: 0;
    font-size: 12px;

    .text-left{
      text-align: left;
    }
    .text-right{
      text-align: right;
    }

    tbody{
      tr{
        cursor: pointer;
        font-size: 12px;
        &:hover{
          background-color: #eeeeee;
        }
      }
    }

    .template_item{
      td{
        vertical-align: middle;
      }
      .client-availability{
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        .inactive-client{
          text-decoration: line-through;
        }
        .client-use-count{
          flex-shrink: 0;
          text-align: right;
        }
      }
      .client{
        p{
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
